import React, { useEffect, useState } from "react";

const Scroll = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Use Intersection Observer to detect when hero section is in view
    const heroSection = document.querySelector(".hero");
    if (!heroSection) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Show scroll indicator when hero is in view
          setIsVisible(entry.isIntersecting);
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of hero is visible
        rootMargin: '0px',
      }
    );

    observer.observe(heroSection);

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleClick = () => {
    // Smooth scroll to Features section with -200px offset
    const featuresSection = document.querySelector(".features");
    if (featuresSection) {
      const featuresPosition = featuresSection.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = featuresPosition - 150; // 200px before the section
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  if (!isVisible) return null;

  return (
    <>
      <div
        className="scroll"
        style={{
          translate: "none",
          rotate: "none",
          scale: "none",
          transform: "translate(-50%, 0%) translate(0.15px, 0%)",
          opacity: isVisible ? "1" : "0",
          transition: "opacity 0.5s ease-in-out",
          cursor: "pointer",
        }}
        onClick={handleClick}
      >
        <span>Scroll to explore</span>
        <div className="l"></div>
      </div>
    </>
  );
};

export default Scroll;
